import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
import EngineSidebar from '../components/EngineSidebar';
import { Outlet } from 'react-router';
import Header from '@/components/Header';
import EngineHeader from '../components/EngineHeader';
import { Toaster } from 'sonner';

export default function EngineLayout() {
  return (
    <>
      <Header />
      <SidebarProvider
        className="relative h-full pt-(--header-height)"
        defaultOpen={true}
      >
        <EngineSidebar />
        <SidebarInset className="flex flex-col h-[calc(100vh-var(--header-height))] overflow-hidden">
          <EngineHeader />
          <main className="flex-1 overflow-auto p-6">
            <Outlet />
          </main>
        </SidebarInset>
      </SidebarProvider>
      <Toaster />
    </>
  );
}
